var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": _vm.maxWidth },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("h3", {
              staticClass: "headline mb-0",
              domProps: { innerHTML: _vm._s(_vm.title) }
            })
          ]),
          _vm._v(" "),
          _c("v-card-text", [
            _vm.waiting
              ? _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c("v-progress-circular", {
                      attrs: { indeterminate: "", color: "primary" }
                    })
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c(
                      "v-form",
                      {
                        ref: "createForm",
                        attrs: { "lazy-validation": "" },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.confirmDialog($event)
                          }
                        },
                        model: {
                          value: _vm.invalid,
                          callback: function($$v) {
                            _vm.invalid = $$v
                          },
                          expression: "invalid"
                        }
                      },
                      [_vm._t("content")],
                      2
                    )
                  ],
                  1
                )
          ]),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "error",
                    text: "",
                    disabled: _vm.waiting || _vm.disabledActions
                  },
                  nativeOn: {
                    click: function($event) {
                      return _vm.cancelDialog($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.cancelLabel) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    text: "",
                    disabled:
                      _vm.waiting ||
                      _vm.disabledActions ||
                      _vm.disabledCreateAction ||
                      _vm.formInvalid
                  },
                  nativeOn: {
                    click: function($event) {
                      return _vm.confirmDialog($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.continueLabel) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }